import { IAuthService } from "../authentication/AuthService";

export interface IApiConfig {
  getAuthorization(): Promise<string>;
  getAuthService(): IAuthService;
  getAccessToken(): Promise<string | undefined>;
  shouldRedirectOnUnauthorized(): boolean;
}

export default class ApiConfig implements IApiConfig {
  private authService: IAuthService;
  private redirectOnUnauthorized: boolean;

  constructor(authService: IAuthService, redirectOnUnauthorized: boolean) {
    this.authService = authService;
    this.redirectOnUnauthorized = redirectOnUnauthorized;
  }

  async getAuthorization(): Promise<string> {
    const token = await this.authService.getAccessToken();
    return token ? `Bearer ${token}` : "";
  }

  async getAccessToken(): Promise<string | undefined> {
    return await this.authService.getAccessToken();
  }

  getAuthService(): IAuthService {
    return this.authService;
  }

  shouldRedirectOnUnauthorized(): boolean {
    return this.redirectOnUnauthorized;
  }
}
